import styled from 'styled-components';
import { Spinner } from 'react-bootstrap';
import { theme } from '../../../theme';

export const DivLoader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${theme.loader.backgroundColor};
  opacity: 0.5;
  z-index: 1051;
  &.fn-loader-fixed {
    position: fixed;
    z-index: 999999;
  }
`;

export const SpinnerBlock = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  z-index: 1051;
`;

export const SpinnerBorder = styled(Spinner)`
  border-width: 2px !important;
  width: 1.846rem !important;
  height: 1.846rem !important;
  border-color: ${theme.colors.primary} ${theme.colors.primary} ${theme.colors.primary} transparent !important;
  animation: lds-dual-ring 0.5s linear infinite !important;
`;
